<div *ngIf="product != null; else loading">
  <div class="row pt-2">
    <div class="col-12">
      <lib-back-button class="ml-5"></lib-back-button>
      <span class="favourite-icon-wrapper">
        <lib-favourite-product-icon [id]="product.id"></lib-favourite-product-icon>
      </span>
    </div>
  </div>

  <div class="row pt-1 product-detail-data-section">
    <!-- Product img -->
    <div class="col-xs-12 col-sm-6 container">
      <div class="row">
        <div class="col-auto">
          <a
            href="https://d27ahaa1qqlr90.cloudfront.net/fit-in/1200x1200/filters:fill(white):background_color(white):etag({{
              product.extra.images[selectedImageIndex].s3ETag
            }}):format(jpeg)/{{ product.extra.images[selectedImageIndex].s3Uri }}"
            class="border-0"
            target="_blank"
          >
            <img
              src="https://d27ahaa1qqlr90.cloudfront.net/fit-in/400x400/filters:fill(white):background_color(white):etag({{
                product.extra.images[selectedImageIndex].s3ETag
              }}):format(jpeg)/{{ product.extra.images[selectedImageIndex].s3Uri }}"
              alt="{{ product.extra.images[selectedImageIndex].description }}"
              class="img-fluid"
            />
          </a>
        </div>
      </div>

      <!-- Product Images carousel -->
      <div *ngIf="!!carousel">
        <div *ngIf="carousel.images.length > 1" class="row pt-2">
          <button
            type="button"
            class="btn col-1"
            [disabled]="carousel.startIndex === 0"
            (click)="scrollImages('left')"
            *ngIf="!carousel.containsAll"
          >
            <i class="fa fa-chevron-left product-images-carousel"></i>
          </button>

          <div *ngFor="let image of carousel.images; trackBy: trackByFn" class="col-3 pb-1 product-detail-image">
            <img
              src="https://d27ahaa1qqlr90.cloudfront.net/fit-in/100x100/filters:fill(white):background_color(white):etag({{
                image.s3ETag
              }}):format(jpeg)/{{ image.s3Uri }}"
              alt="{{ image.description }}"
              class="img-fluid"
              (click)="setSelectedImage(image.s3Uri)"
            />
          </div>

          <button
            type="button"
            class="btn col-1"
            [disabled]="carousel.endIndex + 1 === carousel.countAll"
            (click)="scrollImages('right')"
            *ngIf="!carousel.containsAll"
          >
            <i class="fa fa-chevron-right product-images-carousel"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Product data -->
    <div class="col-xs-12 col-sm-6">
      <div class="row">
        <div class="col-12">
          <h1
            *ngIf="
              product.extra.i18n && product.extra.i18n[currentLang] && product.extra.i18n[currentLang].name;
              else defaultName
            "
          >
            {{ product.extra.i18n[currentLang].name }}
          </h1>
          <ng-template #defaultName>
            <h1>{{ product.name }}</h1>
          </ng-template>
        </div>
      </div>
      <div class="row" *ngIf="product.productType !== 'concept'">
        <div class="col-12">
          <h5 class="mb-0">
            <!-- <span>{{ 'ITEM_NO' | translate }}</span>:  -->
            {{ product.id }}
          </h5>
        </div>
      </div>

      <div class="row" *ngIf="getProductDescription() | async as productDescription">
        <div class="col-12">
          <p class="mb-1 description-line-break">{{ productDescription }}</p>
        </div>
      </div>

      <div class="row" *ngIf="!isNoPrice && product.productType !== 'concept' && !!currentFlow.useAvailabilities">
        <div class="col-12">
          <i class="fas fa-box"></i>&nbsp;
          <lib-availability [availability]="availability" [product]="product" [isSales]="isSales"></lib-availability>
        </div>
      </div>

      <div class="row mt-2" *ngIf="!isNoPrice && product.productType !== 'concept'">
        <div class="col">
          <h4 class="text-lowercase">
            <!-- <strong>{{price.customerNetPrice.value | gungCurrency: price.customerNetPrice.currencyCode:'code' }}</strong> -->
            <lib-price [price]="price" type="NET" [currency]="price.customerNetPrice.currencyCode"></lib-price>
          </h4>
        </div>
      </div>

      <div class="row" *ngIf="!isOnlyDisplayFlow && !isNoPrice && product.productType !== 'concept'">
        <div class="col-12 col-md-6">
          <lib-buy-btn [id]="product.id" [product]="product" [availability]="availability"></lib-buy-btn>
        </div>
      </div>

      <!-- Product Jeeves Details -->
      <div class="pt-2" *ngIf="product.productType !== 'concept'">
        <lib-gung-accordion #acc="gungAccordion" class="accordion-jeeves-product-details">
          <lib-gung-accordion-item id="jeeves-product-details">
              <ng-template libGungAccordionHeader>{{ 'PRODUCT_DETAILS' | translate }}</ng-template>
  
            <ng-template libGungAccordionBody>
              <div class="table-responsive">
                <table class="table table-borderless table-striped table-sm">
                  <tbody>
                    <tr *ngFor="let item of productDetailsTable">
                      <th translate>
                        {{ item.title | uppercase }}
                      </th>
                      <td>
                        {{ item.value }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </lib-gung-accordion-item>

          <lib-gung-accordion-item
            id="jeeves-product-documents"
            *ngIf="product.extra.documents && product.extra.documents.length > 0"
          >
          <ng-template libGungAccordionHeader>{{ 'DOCUMENTS' | translate }}</ng-template>
            <ng-template libGungAccordionBody>
              <div class="table-responsive">
                <table class="table table-hover table-borderless table-striped table-sm">
                  <thead>
                    <tr>
                      <th translate>CATEGORY</th>
                      <th class="text-right" translate>DOWNLOAD_DOCUMENT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let document of product.extra.documents">
                      <td>
                        {{ document.category }}
                      </td>
                      <td class="text-right">
                        <a
                          target="_NEW"
                          [href]="'https://cdn2.gung.io/' + document.s3Uri"
                        >
                          <span translate>{{ getDocumentName(document) }}</span>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </div>
    </div>
  </div>

  <div class="row mt-3 product-detail-data-section">
    <div class="col-12" *ngIf="product.productType !== 'concept'">
      <lib-gung-tabset *ngIf="addonIds.length > 0 || pimRelatedProductsIds.length > 0 || pimSparePartsProductsIds.length > 0">
        <lib-gung-tab *ngIf="addonIds.length > 0" [title]="'ADDONS' | translate">
          <ng-template libGungTabContent>
            <lib-product-list-by-ids [productIds]="addonIds"></lib-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="pimRelatedProductsIds.length > 0" [title]="'PRODUCT_RELATED_PRODUCTS' | translate">
          <ng-template libGungTabContent>
            <lib-product-list-by-ids [productIds]="pimRelatedProductsIds"></lib-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="pimSparePartsProductsIds.length > 0" [title]="'SPAREPARTS' | translate">
          <ng-template libGungTabContent>
            <lib-product-list-by-ids [tabType]="'spareParts'" [productIds]="pimSparePartsProductsIds"></lib-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
    <div class="col-12" *ngIf="product.productType === 'concept'">
      <lib-gung-tabset *ngIf="conceptsIds.length > 0">
        <lib-gung-tab *ngIf="conceptsIds.length > 0" [title]="'ASSORTMENT' | translate">
          <ng-template libGungTabContent>
            <lib-product-list-by-ids [productIds]="conceptsIds"></lib-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
  </div>
</div>

<ng-template #loading> LOADING... </ng-template>
